function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { useDragLayer } from "react-dnd";
import DragItem from "./DragItem.js";

function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: "none"
    };
  }

  var x = currentOffset.x,
      y = currentOffset.y;
  var transform = "translate(".concat(x, "px, ").concat(y, "px)");
  return {
    transform: transform,
    WebkitTransform: transform
  };
}

export var CustomDragLayer = function CustomDragLayer() {
  var _useDragLayer = useDragLayer(function (monitor) {
    return {
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging()
    };
  }),
      itemType = _useDragLayer.itemType,
      isDragging = _useDragLayer.isDragging,
      item = _useDragLayer.item,
      initialOffset = _useDragLayer.initialOffset,
      currentOffset = _useDragLayer.currentOffset;

  if (!item) {
    return null;
  }

  if (!isDragging) {
    return null;
  }

  var layerStyles = {
    position: "fixed",
    pointerEvents: "none",
    zIndex: 100,
    left: 0,
    top: 0,
    width: item.ref && item.ref.current ? item.ref.current.clientWidth : 0,
    height: "100%"
  };
  return /*#__PURE__*/React.createElement("div", {
    style: layerStyles
  }, /*#__PURE__*/React.createElement(DragItem, {
    style: _objectSpread({}, item.style, {}, getItemStyles(initialOffset, currentOffset)),
    name: item.name
  }));
};